<script lang="ts">
  import Vue from "vue";
  import ContentElement from "~/models/contentManagement/contentElement";
  import ObjectModelEntry from "~/models/objectModelEntries/objectModelEntry";

  export default Vue.extend({
    props: {
      contentElement: {
        type: Object as () => ContentElement,
      },
      entry: {
        type: Object as () => ObjectModelEntry,
      },
      isInEditMode: {
        type: Boolean,
        default: false
      }
    }
  })
</script>